/**
 * Checks if given string is a valid json
 * @param jsonString
 * @param logError if log error in console
 * @returns {boolean}
 */
export function isValidJson(jsonString, logError = false) {
  try {
    JSON.parse(jsonString);
  } catch (error) {
    if (logError) {
      console.error(error);
    }
    return false;
  }
  return true;
}

export function isValidAzimuth(azimuth) {
  return Number.isInteger(azimuth) && azimuth >= 0 && azimuth <= 360;
}

export function isPositiveInt(value) {
  return Number.isInteger(value) && value >= 0;
}

export function isPositiveNumber(value) {
  return typeof value === 'number' && value >= 0;
}

export function isValidLatitude(coordinate) {
  return !Number.isNaN(coordinate) && coordinate <= 90 && coordinate >= -90;
}

export function isValidLongitude(coordinate) {
  return !Number.isNaN(coordinate) && coordinate <= 180 && coordinate >= -180;
}
export function isValidMac(mac) {
  return /^([\da-fA-F_xX]{2}:){5}[\da-fA-F_xX]{2}$/.test(mac);
}

export function isValidDate(date) {
  return date instanceof Date && !Number.isNaN(Number(date));
}

// Checks if mui datepicker input is complete/valid
export function validateDateInput(newDate, value) {
  const valid = isValidDate(newDate) || newDate === null;
  return { complete: valid || value, valid };
}

export function isNotEmptyString(val) {
  return typeof val === 'string' && val.trim().length > 0;
}

export function isValidZipCH(val) {
  return /^\d{4}$/.test(String(val));
}

export function isValidLatCH(val) {
  const lat = parseFloat(val);
  return !Number.isNaN(lat) && lat >= 45.8 && lat <= 47.8;
}

export function isValidLonCH(val) {
  const lon = parseFloat(val);
  return !Number.isNaN(lon) && lon >= 5.9 && lon <= 10.5;
}
